import { render } from "./ReorderCustomListsModal.vue?vue&type=template&id=6c960bf5&scoped=true"
import script from "./ReorderCustomListsModal.vue?vue&type=script&lang=js"
export * from "./ReorderCustomListsModal.vue?vue&type=script&lang=js"

import "./ReorderCustomListsModal.vue?vue&type=style&index=0&id=6c960bf5&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c960bf5"]])

export default __exports__